import { HttpParams } from '@angular/common/http';
import { ApiQueryParams } from '../../types';
import { buildDeepPopulate } from './build-deep-populate.helper';

/**
 * Build the `HttpParams` for a request
 *
 * @description
 * A helper function that provides an easy way to build the query parameters to send in an HTTP request
 *
 * @param query the query params to build
 *
 * @returns an instance of `HttpParams` containing the specified parameters
 */
export function buildQueryParams(query: ApiQueryParams): HttpParams {
    let params = new HttpParams();

    if (query.deepPopulate) params = params.set('deepPopulate', JSON.stringify(buildDeepPopulate(query.deepPopulate)));
    if (query.limit) params = params.set('limit', query.limit);
    if (query.offset) params = params.set('skip', query.offset);
    if (query.sort) params = params.set('sort', query.sort);
    if (query.select) params = params.set('select', query.select.join(','));
    if (query.populate) params = params.set('populate', query.populate.join(','));
    if (query.filter) params = params.set('filter', JSON.stringify(query.filter));

    return params;
}
